import React, {useEffect} from 'react';
import 'typeface-roboto';
import './assets/geometria-webfont/style.css'
import './main.css';
import {MenuAppBar} from '@cabinet-packages/components';
import PageController from './pages/PageController';
import 'react-virtualized/styles.css';
import {useDispatch, useSelector} from "react-redux";
import {setClient, setListOfPatients} from "@cabinet-packages/redux";
import {useAppState} from "@cabinet-packages/hooks";
import {MuiThemeProvider} from "@material-ui/core";
import themeMaterialUI from "./settings/themeMaterialUI";
import logo from './assets/images/logo.svg';
import routes from "./settings/routes";

function LandingPage() {
    const dispatch = useDispatch();
    const { client } = useAppState();

    const {activePatient, listOfPatients} = useSelector(state => state.patients);

    useEffect(() => {
        if (!listOfPatients) dispatch(setListOfPatients());
    }, [dispatch, listOfPatients])

    useEffect(() => {
        if (client && (!activePatient || !listOfPatients)) {
            dispatch(setClient(client));
        }
    }, [client, activePatient, dispatch, listOfPatients]);

    return (<div className="App">
        <MenuAppBar logo={logo} themeMaterialUI={themeMaterialUI} routes={routes}/>
        <MuiThemeProvider theme={themeMaterialUI}>
            <PageController/>
        </MuiThemeProvider>
    </div>);
}

export default LandingPage;
